module.exports = __webpack_public_path__ + "img/18.2ef9d229.png";